function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { cx } from '@emotion/css';
import Trigger from "../Trigger";
import { ArrowRightOutlinedIcon } from "../Icons";
import { cssDropdown, menuDangerClass, menuDisabledClass, menuDividerClass, menuItemClass, menuItemIconClass, prefix, subMenuClass, menuItemRightArrowClass, menuUnclickableClass } from "./style";
import useEvent from "../../hooks/useEvent";
import useThemeProps from "../../hooks/useThemeProps";

var DropdownMenu = function DropdownMenu(props) {
  var size = props.size,
      onClick = props.onClick,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items;
  return /*#__PURE__*/React.createElement("div", null, items.map(function (item) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      size: size,
      key: item.key,
      onClick: onClick,
      item: item
    });
  }));
};

var MenuItem = function MenuItem(props) {
  var size = props.size,
      _onClick = props.onClick,
      item = props.item,
      _props$level = props.level,
      level = _props$level === void 0 ? 1 : _props$level;
  var _item$type = item.type,
      type = _item$type === void 0 ? 'default' : _item$type,
      _item$groupItemClicka = item.groupItemClickable,
      groupItemClickable = _item$groupItemClicka === void 0 ? true : _item$groupItemClicka,
      danger = item.danger,
      disabled = item.disabled,
      startIcon = item.startIcon,
      key = item.key,
      label = item.label,
      children = item.children;
  var theme = useThemeProps();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      internalOpen = _useState2[0],
      setInternalOpen = _useState2[1];

  var onItemClick = useEvent(function (item) {
    if (item.disabled || item.type === 'default' && item.children && item.children.length > 0) return;
    setInternalOpen(false);
  });

  if (type === 'divider') {
    return /*#__PURE__*/React.createElement("div", {
      className: menuDividerClass()
    }, /*#__PURE__*/React.createElement("div", null));
  } // 当前item，不包括任何children


  var menu = /*#__PURE__*/React.createElement("div", {
    className: cx(menuItemClass(), danger && menuDangerClass(), disabled && menuDisabledClass(), _defineProperty({}, menuUnclickableClass(), type === 'group' && !groupItemClickable)),
    onClick: function onClick(e) {
      if (!disabled && !(type === 'group' && !groupItemClickable)) {
        _onClick && _onClick({
          item: item,
          key: key,
          domEvent: e
        });
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: level > 1 ? {
      paddingLeft: (level - 1) * 16
    } : {}
  }, startIcon && /*#__PURE__*/React.createElement("span", {
    className: menuItemIconClass()
  }, startIcon), ['string', 'number'].includes(_typeof(label)) ? /*#__PURE__*/React.createElement("span", null, label) : label), type === 'default' && children && children.length > 0 && /*#__PURE__*/React.createElement(ArrowRightOutlinedIcon, {
    className: menuItemRightArrowClass()
  })); // 有children，把children加上去

  if (type === 'group' && children && children.length > 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, menu, children.map(function (child) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: child.key,
        size: size,
        level: level + 1,
        onClick: _onClick,
        item: child
      });
    }));
  }

  if (type === 'default' && children && children.length > 0) {
    return /*#__PURE__*/React.createElement(Trigger, {
      prefixCls: prefix(),
      popup: /*#__PURE__*/React.createElement(DropdownMenu, {
        size: size,
        onClick: function onClick(props) {
          onItemClick(props.item);
          _onClick === null || _onClick === void 0 ? void 0 : _onClick(props);
        },
        items: children
      }),
      popupVisible: internalOpen,
      onPopupVisibleChange: setInternalOpen,
      popupClassName: cx(cssDropdown(theme), prefix(), prefix("-".concat(size))(), subMenuClass()),
      placement: "rt",
      getPopupContainer: function getPopupContainer(target) {
        return (target === null || target === void 0 ? void 0 : target.parentElement) || document.body;
      }
    }, menu);
  }

  return menu;
};

MenuItem.displayName = 'MenuItem';
DropdownMenu.displayName = 'DropdownMenu';
export default /*#__PURE__*/React.memo(DropdownMenu);